import React from 'react';
import {Redirect, Route} from 'react-router-dom';
import TTLProxy from "./TTLAsyncProxy";
import {UserRoles} from "./Constants";
import Utils from "./Utils";
import PropTypes from "prop-types";
import {hasAllPermissions} from "../components/PermissionRender/PermissionRender";

const LoadComponent = (componenents,role) => {

    let comp = componenents.find((item) => item.role === role);
    if(comp){
        return comp.component;
    }

};

export default class RoutePrivate extends Route {

    render() {

        const props = this.props;
        const proxy = TTLProxy.getInstance();
        const userRole = proxy.getUserRole();
        const superUser = props.requireSuperUser;
        const departments = props.departments;
        const permissions = props.permissions;

        const redirectRoute = () => {
            return <Redirect to={{ pathname: ( props.redirectPath || '/login') }}/>;
        };

        if (proxy.isAuthenticated()){

            const user = proxy.getUserInfo();

            //  has role restrictions ??
            if(props.roles){

                if(!Utils.hasRole(userRole,props.roles))
                    return null;

            }

            if(departments && userRole === UserRoles.Admin && user.admin.departments && !user.admin.super_user){

                if(!departments.every(d => user.admin.departments.includes(d))){
                    return  redirectRoute();
                }

            }

            if((permissions && !hasAllPermissions(user.permissions,permissions))){
                return redirectRoute();
            }

            //  check super user
            if((superUser && !user.admin.super_user)){
                return redirectRoute();
            }

            let component;
            if(this.props.components){
                component = LoadComponent(this.props.components,proxy.getUserRole());
            }
            else if(this.props.component){
                component = this.props.component;
            }

            return (<Route
                path={this.props.path}
                name={this.props.name}
                replace={false}
                exact={this.props.exact}
                component={component}/>);
        }

        return redirectRoute()
    }
}

RoutePrivate.propTypes = {
    roles: PropTypes.any,
    departments: PropTypes.any,
    requireSuperUser: PropTypes.bool,
    path: PropTypes.string,
    component: PropTypes.any,
    components: PropTypes.array,
    name: PropTypes.string,
    redirectPath: PropTypes.string,
    permissions: PropTypes.arrayOf(PropTypes.string)
};


// WEBPACK FOOTER //
// ./src/common/RouterPrivate.js